export default __webpack_public_path__ + "static/media/dollar-sign.abb7953b.svg";